import {HttpService} from "../../service/HttpService"
import {Custom} from "../Custom"
import ProfilePage from "./ProfilePage";

export const Profile = () => {
    const customProject = HttpService?.customProject

    return (
        <>
            {
                customProject?.customFrontend && customProject?.frontendComponents?.some(component => component?.pathUrl === "/profile-custom")
                    ? (
                        <Custom
                            customFrontendUrl={customProject?.customFrontendUrl}
                            type={customProject?.frontendComponents?.find(comp => comp?.pathUrl === "/profile-custom")?.component}
                        />
                    ) :
                    <ProfilePage />
            }
        </>
    )
}